const entryType = 'wix';

const FIELDS = [
    'cdn',
    'dc',
    'microPop',
    'caching',
    'is_rollout',
    'is_platform_loaded',
    'maybeBot'
];

export default function wix(window) {
    return new Promise((resolve, reject) => {
        window.addEventListener('load', () => {
            const {wixBiSession, boltVersion, clientSideRender, ssrInfo} = window;
            if (!wixBiSession) {
                reject(entryType);
                return;
            }
            const result = {
                entryType
            };
            addField(result, 'v', boltVersion);
            addField(result, 'is_ssr', !clientSideRender);
            if (ssrInfo) {
                addField(result, 'ssrDuration', ssrInfo.timeSpentInSSR);
            }
            addField(result, 'viewer_name', wixBiSession.renderType);
            FIELDS.forEach(field => addField(result, field, wixBiSession[field]));
            resolve(result);
        }, {
            once: true,
            passive: true
        });
    });
}

function addField(result, key, value) {
    if (typeof value !== 'undefined') {
        result[key] = value;
    }
}
